import { useEffect, useState } from 'react';

export function useSmallScreenModal(initialDisabledModalMobile = true) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [disabledModalMobile, setDisabledModalMobile] = useState(
    initialDisabledModalMobile
  );

  useEffect(() => {
    const handleResize = () => {
      if (disabledModalMobile) {
        setIsSmallScreen(false);
        return;
      }
      setIsSmallScreen(window.innerWidth < 1000);
    };

    handleResize();

    if (!disabledModalMobile) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [disabledModalMobile]);

  return { isSmallScreen, setDisabledModalMobile };
}
